<div>
    <div class="m-t-15 m-b-10">
        <span>{{ question.name }}</span>
    </div>
</div>
<div class="m-l-20 table-responsive">

    <div class="flex-row table-head">
        <div class="matrix-element" style="visibility:hidden;">{{ getMaxRowNameLength(answerRows) }}</div>
        <div class="matrix-element" *ngFor="let column of answerColumns">{{ column.name }}</div>
    </div>

    <div *ngFor="let row of getAnswerRowControls(); let rowIndex = index;" class="flex-row">
        <div class="matrix-element">{{ getRowAnswer(rowIndex).name }}</div>
        <div class="matrix-element" *ngFor="let column of getAnswerColumnControls(); let columnIndex = index;">
            <input [name]="getRowAnswer(rowIndex).name.split(' ').join('_')+question.id+'_'+rowIndex"
                   [type]="(getIsMatrixCheckbox()) ? 'checkbox' : 'radio'"
                   [formControl]="column"
                   class="with-gap"
                   [checked]="isChecked(rowIndex, columnIndex)"
                   [id]="getUniqueInputName(rowIndex, columnIndex)"
                   (click)="selectAnswer(rowIndex, columnIndex)"/>
            <label class="answer-text matrix-label" [for]="getUniqueInputName(rowIndex, columnIndex)"></label>
        </div>


    </div>
</div>